module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "ranking-panel"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n        " + _vm._s(_vm.activatedClub.leagues[0].name) + "\n        "), _c('hr')]), _vm._v(" "), (_vm.activatedClub) ? _c('div', {
    staticClass: "panel-content"
  }, [_vm._l((_vm.activatedClub.leagues[0].ranking_groups), function(rg) {
    return _c('rankingGroupPanel', {
      key: _vm.activatedClub.leagues[0].ranking_groups,
      attrs: {
        "rankingGroup": rg
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('router-link', {
    staticClass: "bottom-link",
    attrs: {
      "to": {
        name: 'rankingGeneral'
      }
    }
  }, [_vm._v("Voir le classement détaillé...")])], 1)], 2) : _c('div', [_c('spinner')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c01d86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ranking-panel.vue
// module id = 722
// module chunks = 0